import createAPIRequest from "../helpers/createAPIRequest";
import handleError from "../helpers/handleError";
import store from "../store/index";

//------------------
// delete combatant
//------------------
export default async function useDeleteCombatant(slug) {
  let api_call = null;
  //--------------
  // access store
  //--------------
  const this_store = store;
  //--------------------
  // set api call parms
  //--------------------
  let request_parms = {
    endpoint: "api/v1/combatants/",
    slug: slug,
    deleteInd: true,
  };
  //--------------------
  // create api request
  //--------------------
  let request = createAPIRequest(request_parms);
  //------------------
  // set slug request
  //------------------
  let slug_request = {
    request: request,
    slug: slug,
  };
  //--------------------------------
  // make store API call (deletion)
  //--------------------------------
  api_call = this_store.dispatch("combat/deleteCombatant", slug_request);
  //---------------
  // await results
  //---------------
  await api_call
    //----------
    // where ok
    //----------
    .then(() => {})
    //-------------
    // where error
    //-------------
    .catch((err) => {
      handleError(err,9);
    });
}
